module.exports = __webpack_public_path__ + "media/images/instructions/4-a230eb4d58138c408405b50e1dc45830.png";